__webpack_require__.p = "static_url_placeholder";